import classNames from 'classnames'
import * as React from 'react'

import { Colour } from 'components/variables'
import './Box.scss'

export enum BoxType {
  large = 'large',
  fullWidthMobile = 'fullWidthMobile',
  flavour = 'flavour',
  blueHeaders = 'blueHeaders',
  lightPinkHeaders = 'lightPinkHeaders',
  gloryColorHeaders = 'gloryColorHeaders',
  tomatoHeaders = 'tomatoHeaders',
  celadon = 'celadon',
  golden = 'golden',
  paleTurquoise = 'paleTurquoise',
  shalimar = 'shalimar',
  halfWidthImage = 'halfWidthImage',
  pattern = 'pattern',
  badge = 'badge',
}

interface BoxProps {
  large?: boolean
  fullWidthMobile?: boolean
  type?: BoxType
  colour?: Colour
  patternImage?: string
  backgroundImage?: string
  children?: React.ReactNode | undefined
}

const Box: React.FC<BoxProps> = props => {
  const className = classNames(
    'srprs-box',
    props.large ? 'type-large' : '',
    props.fullWidthMobile ? 'is-fullWidthMobile' : '',
    props.type ? `type-${props.type}` : '',
    props.colour && `colour-${props.colour}`,
  )

  const backgroundUrl = props.backgroundImage
    ? `url(${props.backgroundImage})`
    : ''
  const patternUrl = props.patternImage ? `url(${props.patternImage})` : ''

  return (
    <div className={className} style={{ backgroundImage: backgroundUrl }}>
      {props.patternImage !== undefined ? (
        <>
          <div
            className="box-pattern"
            style={{ backgroundImage: patternUrl }}
          />
          <div className="box-box">{props.children}</div>
        </>
      ) : (
        props.children
      )}
    </div>
  )
}

Box.defaultProps = {
  large: false,
}

interface BoxFooterProps {
  ctaButton: JSX.Element
  children?: React.ReactNode | undefined
}

const BoxFooter: React.FC<BoxFooterProps> = props => {
  return (
    <footer className="clearfix">
      <div>{props.children}</div>
      <div className="cta-button">{props.ctaButton}</div>
    </footer>
  )
}

export { Box, BoxFooter }
